import { ThunkType } from "../../../../../core/store/reducers";
import { setData } from "../annualSecurityDataSlice";
import getAnnualSecurityDataApi from "../api/getAnnualSecurityData";

export const loadReport = (): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return undefined;
	}

	const user = store.data.auth.current.user;
	const { filter } = store.ux.reports.securityCommission.annualSecurity;

	const pagedTrades = await dispatch(getAnnualSecurityDataApi(user, filter));

	dispatch(setData(pagedTrades || []));
};
